import { Component, Inject, OnInit } from '@angular/core';
import { TemplateExplorerService } from '../templates/template-explorer/template-explorer.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Options } from '@angular-slider/ngx-slider';

export interface CptTimeAssociationDialogComponent {
  company_id: string;
  element: any;
}
@Component({
  selector: 'app-cpt-time-association-dialog',
  templateUrl: './cpt-time-association-dialog.component.html',
  styleUrls: ['./cpt-time-association-dialog.component.css']
})
export class CptTimeAssociationDialogComponent implements OnInit {
  cpts: any;
  model: any = {}
  cptCodesDropdownSettings: any = {};
  loaderId = 'cpt-time-association-dialog-loader';
  selectedCpts: any = [];
  companyId: any;
  startTime: number = 0;
  endTime: number = 0;
  selectedCodes = [];
  constructor(
    private templateExplorerService: TemplateExplorerService,
    private loader: NgxUiLoaderService,
    private toastr: ToastrService,
    private companyService: CompanyService,
    public dialogRef: MatDialogRef<CptTimeAssociationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CptTimeAssociationDialogComponent,

  ) {
    if (data) {
      this.companyId = data;
    }
    this.cptCodesDropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'codeDescription',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true,
      enableCheckAll: false,
    };
  }

  async ngOnInit() {
    this.loader.startLoader(this.loaderId);
    await this.initcptCodes();
    this.loader.stopLoader(this.loaderId);
  }

  async initcptCodes() {
    return new Promise<void>((resolve, reject) => {
      this.templateExplorerService.getAllCPTs().subscribe((response: any) => {
        if (response.status == 200) {
          this.cpts = response.data;
          resolve();
        } else {
          this.toastr.error('Something went wrong!', 'Error');
        }
      }, err => {
        reject();
        this.toastr.error('Something went wrong!', 'Error');
      });
    })
  }

  onSaveClick() {
    this.model.startTime = this.convertToSeconds(this.startTime);
    this.model.endTime = this.convertToSeconds(this.endTime);
    this.model.cpts = this.selectedCpts;
    this.createCptTimeRelation(this.companyId, this.model);
  }

  async onCodeSelect(element, $event) {
    let isCreating = true;
    this.selectedCpts.push($event._id);
  }

  async onCodeDeSelect(element, $event) {
    let isCreating = false;
    const index = this.selectedCpts.indexOf($event._id);
    if (index >= 0) {
      this.selectedCpts.splice(index, 1);
    }
  }


  async createCptTimeRelation(companyId, model: {}) {
    this.companyService.createCptTimeRelation(companyId, model).subscribe((res: any) => {
      if (res.status == 200) {
        this.dialogRef.close(true);
        this.toastr.success('Relation Updated!', 'Success');
      } else {
      }
    });
  }

  formatTime(minutes: number): string {
    if (minutes > 0) {
      return `${minutes}`;
    }
    return `00`;
  }

  convertToSeconds(minutes: number): number {
    return minutes * 60;
  }

  padZero(num: number): string {
    return num < 10 ? `0${num}` : num.toString();
  }
}
